class NavMockups extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setActiveLink();
  }

  setActiveLink() {
    const mocksItems = this.querySelectorAll('a');
    const urlParams = new URLSearchParams(window.location.search);
    const activeFilters = urlParams.toString();

    mocksItems.forEach(mocksItem => {
      const linkFilters = new URL(mocksItem.href).searchParams.toString();

      mocksItem.classList.toggle('active', activeFilters.includes(linkFilters));
    });
  }
}

customElements.define('nav-mockups', NavMockups);
